import { Card, CardContent, Box, Typography, Button, useTheme } from '@mui/material';
import { AvailableAddon, OrderedAddon } from 'stores/AddonStore';
import { Add, Remove } from '@mui/icons-material';

type AddonCardProps = {
  addon: AvailableAddon | OrderedAddon;
  handleAddonClick: (addonId: string) => void;
};

const isAvailableAddon = (addon: AvailableAddon | OrderedAddon): addon is AvailableAddon => {
  return (addon as AvailableAddon).isSelected !== undefined;
};

const AddonCard = ({ addon, handleAddonClick }: AddonCardProps) => {
  const addonIsAvailable = isAvailableAddon(addon);
  const theme = useTheme();

  const textColor = addonIsAvailable ? theme.palette.text.primary : theme.palette.text.disabled;

  return (
    <Card
      onClick={() => {
        handleAddonClick(addon._id);
      }}
      key={addon.title}
      style={{
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '150px',
        marginBottom: '16px',
        outline: addonIsAvailable
          ? addon.isSelected
            ? '2px solid #4260D3'
            : 'none'
          : '2px solid rgba(34, 34, 34, 0.38)',
        boxShadow: 'none',
        padding: '8px 8px 0px 8px',
        cursor: addonIsAvailable ? 'pointer' : 'initial',
      }}
    >
      <CardContent sx={{ paddingBottom: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '4px',
          }}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 'bold',
              color: textColor,
            }}
          >
            {addon.title}
          </Typography>
          <Typography variant="body2" style={{ color: textColor }}>
            ${addon.price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </Typography>
        </Box>
        <Box
          sx={{
            marginBottom: '8px',
            maxWidth: '400px',
          }}
        >
          <Typography variant="body2" style={{ color: textColor }}>
            {addon.description}
          </Typography>
        </Box>
        {addonIsAvailable && (
          <Button variant="outlined" color="primary">
            {addon.isSelected ? (
              <>
                <Remove sx={{ verticalAlign: 'middle', marginBottom: '1px', marginRight: '8px' }} />
                REMOVE
              </>
            ) : (
              <>
                <Add sx={{ verticalAlign: 'middle', marginBottom: '1px', marginRight: '8px' }} />
                ADD
              </>
            )}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default AddonCard;
